import { PHASE_FIRMWARE, PHASE_HEALTH_FAULTS, PHASE_USAGE } from '../../constants';
import { getFirmwareCompliance } from '../../helpers/getFirmwareCompliance';
import { DRONES } from '../../mockData';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { NEXT_SERVICE_SUB, NEXT_SERVICE_VALUE, PERCENT_MULTIPLIER, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const KpiStrip: FunctionComponent<Props> = ({ className = '', phase, testId = TEST_ID }) => {
    const {
        ACTIVE_WARNINGS,
        FIRMWARE_COMPLIANCE,
        NEXT_SERVICE_DUE,
        NOT_APPLICABLE_NOT_REPORTED,
        TOTAL_DRONES
    } = useTranslation();

    const grounded = DRONES.filter(drone => drone.readiness === 'grounded').length;
    const active = DRONES.length - grounded;
    const critical = DRONES.filter(drone => drone.status === 'critical').length;
    const caution = DRONES.filter(drone => drone.status === 'caution').length;
    const warnings = DRONES.filter(drone => drone.topWarning !== null).length;
    const { compliant, total } = getFirmwareCompliance(DRONES);
    const fwFill = { width: `${Math.round((compliant / total) * PERCENT_MULTIPLIER)}%` };

    return (
        <Wrapper className={`${styles.kpiStrip} ${className}`} testId={testId}>
            <VerticalContainer className={styles.kpiTile}>
                <Wrapper className={styles.kpiLabel}>{TOTAL_DRONES}</Wrapper>

                <Wrapper className={styles.kpiValue}>{DRONES.length}</Wrapper>

                <Wrapper
                    className={styles.kpiSub}>{`${active} active · ${grounded} grounded`}</Wrapper>
            </VerticalContainer>

            {phase >= PHASE_USAGE && (
                <VerticalContainer className={styles.kpiTile}>
                    <Wrapper className={styles.kpiLabel}>{NEXT_SERVICE_DUE}</Wrapper>

                    <Wrapper className={styles.kpiValue}>{NEXT_SERVICE_VALUE}</Wrapper>

                    <Wrapper className={styles.kpiSub}>{NEXT_SERVICE_SUB}</Wrapper>
                </VerticalContainer>
            )}

            {phase >= PHASE_FIRMWARE && (
                <VerticalContainer className={styles.kpiTile}>
                    <Wrapper className={styles.kpiLabel}>{FIRMWARE_COMPLIANCE}</Wrapper>

                    <Wrapper className={styles.kpiValue}>{`${compliant} / ${total}`}</Wrapper>

                    <Wrapper className={styles.fwBar}>
                        <div className={styles.fwBarFill} style={fwFill} />
                    </Wrapper>

                    <Wrapper className={styles.fwSub}>{NOT_APPLICABLE_NOT_REPORTED}</Wrapper>
                </VerticalContainer>
            )}

            {phase >= PHASE_HEALTH_FAULTS && (
                <VerticalContainer className={styles.kpiTile}>
                    <Wrapper className={styles.kpiLabel}>{ACTIVE_WARNINGS}</Wrapper>

                    <Wrapper className={styles.kpiValue}>{warnings}</Wrapper>

                    <Wrapper className={styles.kpiSub}>
                        <Wrapper className={styles.kpiCritical}>{`${critical} critical`}</Wrapper>

                        {' · '}

                        <Wrapper className={styles.kpiCaution}>{`${caution} caution`}</Wrapper>
                    </Wrapper>
                </VerticalContainer>
            )}
        </Wrapper>
    );
};

export default KpiStrip;
